/*global analytics*/
import React, { Component } from "react";

export default class ShareEmail extends Component {

    handleClick = () => {
        analytics.track('Clicked Element', {
            element_name: 'Email Share'
          });
    }

    buildHREFForEmail = () => {
        const { isSharedBox, firstName } = this.props;
        let base = "mailto:?subject=";
        let subject = isSharedBox ? `Check out ${firstName}'s FabFitFun box!` : "Check out my FabFitFun box!";
        let body = isSharedBox ? `${firstName} just customized their FabFitFun Box. Take a look here. ${this.props.url}` : `I just customized my FabFitFun box. Take a look here. ${this.props.url}`;
        let finalMailToInstructions = `${subject}&body=${body}`
        return base + finalMailToInstructions;
    }

    render(){
        return (
        <a href={this.buildHREFForEmail()}>
            <div 
                className="smb__icon smb__icon--email smb__icon--no-margin" 
                onClick={this.handleClick}
                title="Share with e-mail"
            >
                <i className="fal fa-envelope"></i>
            </div>
        </a>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/ShareMyBox/ShareEmail/ShareEmail.js